import axios from '@/http/index'

// 获取token
export const getLoginStatus = (params) => {
    return axios({
        method: 'GET',
        url: 'https://user.tsgyun.com/user/get-login-status',
		params
    })
}

// 用户退出接口2
export const userLogout2 = (params) => {
    return axios({
        method: 'POST',
        url: 'https://user.tsgyun.com/user/logout',
		params
    })
}

// 获取用户信息
export const getUser = (params) => {
    return axios({
        method: 'GET',
        url: 'https://qfxcte.qfxuexi.com/login/get-current-user',
		params
    })
}

// 用户退出接口
export const userLogout = (params) => {
    return axios({
        method: 'GET',
        url: '/login/logout',
		params
    })
}
//判断是否登录
export const getCurrUser = (params) => {
    return axios({
        method: 'GET',
        url: '/management_ai/basic/curr_user',
        params
    })
}